/**
 * Import Dependency
 */
// import * as userAction from '../../actions/components/user'
import _ from 'lodash'
import * as moment from 'moment'
import { createAction } from 'redux-actions'
import * as basketAction from '../../actions/components/basket'
import { GET_MERCHANT } from '../../constants/actionType'
import merchant from '../../services/api/merchant'
import { Merchant } from 'models/merchant'

/**
 * Declare Variable
 */
const getMerchantAction = createAction(GET_MERCHANT)

/**
 * Export
 */
export const linkMerchant = () => async (dispatch, getState) => {
  try {
    const res = await merchant.link()
    if (res.params) {
      window.location.href = [
        `${window.location.protocol}//`,
        window.location.host,
        '?',
        res.params,
        '&t=',
        res.table,
        '&change_table=1',
      ].join('')
    }

    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}
export const getMerchant = (merchantId) => async (dispatch, getState) => {
  try {
    const res = await merchant.get(merchantId).then(m => {
      if (_.isArray(m.shippings)) {
        m.shippings = m.shippings.map(s => {
          return {
            ...s,
            ...('maxDeliveryMinute' in s) && { maxDeliveryHour: (s.maxDeliveryMinute || 0) / 60 },
            ...('minDeliveryMinute' in s) && { minDeliveryHour: (s.minDeliveryMinute || 0) / 60 },
          }
        })
      }
      return new Merchant(m)
    })
    if (res.id !== merchantId) {
      console.log('TOKEN_MISMATCH', 'token merchant != merchantId', `token:${res.id}`, `merchantId:${merchantId}`)
    }
    dispatch(getMerchantAction(res))
    const state = getState()
    const isDeliveryAvailable = state.merchant.setting.enableDelivery && dispatch(getIsInDeliveryTimeslot())
    if (!isDeliveryAvailable) {
      dispatch(basketAction.setDeliveryAvailable(false))
    }
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getTimeslot = (merchantId) => async (dispatch) => {
  try {
    const res = await merchant.getTimeslot(merchantId)
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getIsInDeliveryTimeslot = () => (dispatch) => {
  const now = moment()
  const beforeTime = moment('11:20:00', 'hh:mm:ss')
  const afterTime = moment('15:00:00', 'hh:mm:ss')

  if (now.isBetween(beforeTime, afterTime)) {
    return false
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/merchant.js